import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableRow,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import SelectMenuItem from "../Customer/Component/SelectMenuItem";
import { useUpdateCustomerMutation } from "../../../Service/customers";
import { useDispatch, useSelector } from "react-redux";
import { GetcustomerList } from "../../../store/async-actions/digitalmarketing/dashboard";
import { useGetDashboardCustomersQuery } from "../../../Service/dashboard";
import { ServiceChosen } from "./Utils";
import { GrScheduleNew } from "react-icons/gr";
import moment from "moment";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import schedule from "../../../assets/DigitalMarketing/image/Schedule.svg";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import { useDeleteAppointmentMutation } from "../../../Service/appoinment";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import { useDeleteReminderMutation } from "../../../Service/reminder";
import PermissionCheck from "../../../Component/PermissionCheck";
import TableLoad from "../../../Component/DigitalMarketing/Tableload";
const useStyles = makeStyles({
  Mimo: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FB6A6A",
      backgroundColor: "#FFF7F7",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Fertility: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3BB54A",
      backgroundColor: "#F7FFF8",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Action: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  status: {
    width: 148,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
});
interface props {
  customer_list: any;
  getComparator: any;
  order: any;
  orderBy: string;
  handleClick: any;
  handleChange: any;
  stableSort: any;
  refetch: any;
}
function TableList({
  customer_list,
  getComparator,
  order,
  orderBy,
  handleClick,
  handleChange,
  stableSort,
  refetch,
}: props) {
  const classes = useStyles();
  const [ishover, sethover] = useState(null);
  const handleMouseEnter = (index) => {
    sethover(index);
  };
  const { open, message, openDelete, deleteId } = useDeleteBox();

  const [deleteReminder] = useDeleteReminderMutation();
  const DashboardStatus = useSelector((state: any) => state.dashboard.status);
  let status = DashboardStatus.map((item) => ({
    label: item.name,
    value: item.id,
    icon: (
      <span
        style={{ backgroundColor: item.others }}
        className="blue me-2"
      ></span>
    ),
  }));
  // console.log(status);
  const Delete = async (bool) => {
    if (bool) {
      await deleteReminder(deleteId);
      refetch();
    }
    openDelete("Are you sure you want to delete this reminder?", false, null);
  };

  const DateConditionCheck = (todate) => {
    if (todate) {
      const specificDate = new Date(todate);
      const currentDate = new Date();
      return (
        moment(currentDate).format("DD-MM-YYYY") >
        moment(specificDate).format("DD-MM-YYYY")
      );
    }
    return false;
  };
  return (
    <>
      <>
        <AlertDialog open={open} message={message} deleteBranches={Delete} />
      </>
      {stableSort(customer_list, getComparator(order, orderBy))?.map((a, i) => {
        return (
          <TableRow
            // hover
            style={{
              background: DateConditionCheck(a.toDate) ? "#f3d9d9" : "",
            }}
            role="checkbox"
            tabIndex={-1}
            key={i}
          >
            <TableCell align="left">{a.customerName}</TableCell>
            <TableCell align="left">{a.phone1}</TableCell>
            <TableCell align="left">{a.templateName}</TableCell>
            <TableCell align="left">
              {a.fromDate && moment(a.fromDate).format("DD-MM-YYYY")}
            </TableCell>
            <TableCell align="left">
              {a.toDate && moment(a.toDate).format("DD-MM-YYYY")}
            </TableCell>
            <TableCell align="left">
              {/* {PermissionCheck("reminders/", "delete") && ( */}
                <img
                  src={dele}
                  onClick={() =>
                    openDelete(
                      "Are you sure you want to delete this reminder?",
                      true,
                      a.remindersId
                    )
                  }
                  className="delete-icon cursur action-icon"
                />
              {/* )} */}
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
